import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import CountryMenu from '/@/components/country-menu';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getSessionCountries } from '/@/store/session/selectors';
import Select from '/@/v3/components/forms/select';
import styles from './styles.module.css';

@connect((state, props) => {
    const countries = getSessionCountries(state);
    return { country: countries.find(({ id }) => id === props.country), countries };
})
@autobind
export default class LocalePreferences extends Component {
    static propTypes = {
        language: PropTypes.string.isRequired,
        country: PropTypes.shape({
            code: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
        countries: PropTypes.arrayOf(
            PropTypes.shape({
                code: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })
        ),
        onChange: PropTypes.func.isRequired,
        openUp: PropTypes.bool,
        appearance: PropTypes.oneOf(['row', 'column']),
        persistPlaceholder: PropTypes.bool,
        showCountry: PropTypes.bool,
        whiteColor: PropTypes.bool,
        textColor: PropTypes.oneOf(['grey']),
        handleCountryChange: PropTypes.func,
        upperCase: PropTypes.bool,
        showLanguage: PropTypes.bool,
        className: PropTypes.string,
        classNameOptions: PropTypes.string,
    };

    static defaultProps = {
        openUp: true,
        appearance: 'column',
        persistPlaceholder: false,
        upperCase: false,
        showLanguage: true,
    };

    state = {
        disabled: false,
    };

    handleCountryChange(country) {
        this.handleChange({ country: country.id, language: this.props.language });
    }

    handleLanguageChange(language) {
        this.handleChange({ language, country: this.props.country.id });
    }

    async handleChange({ country, language }) {
        this.setState({ disabled: true });
        await this.props.onChange({ country, language });
        this.setState({ disabled: false });
    }

    upperCaseOptions() {
        const upper = settings.languages.map((element) => {
            return { value: element.value, label: element.label.toUpperCase().slice(0, 3) };
        });
        return upper;
    }

    render() {
        const {
            appearance,
            openUp,
            persistPlaceholder,
            countries,
            country,
            language,
            upperCase,
            className,
            classNameOptions,
            showCountry,
            showLanguage,
        } = this.props;
        return (
            <div className={classNames(styles.root, styles[`appearance-${appearance}`])}>
                {showCountry && (
                    <CountryMenu
                        openUp={openUp}
                        countries={countries}
                        selectedCountry={country}
                        onChange={this.handleCountryChange}
                    />
                )}
                {showLanguage && (
                    <Select
                        placeholder={_('Idioma')}
                        clearable={false}
                        persistPlaceholder={persistPlaceholder}
                        value={language}
                        options={upperCase ? this.upperCaseOptions() : settings.languages}
                        onChange={this.handleLanguageChange}
                        disabled={this.state.disabled}
                        className={classNames(upperCase && styles.selectLanguage, className)}
                        classNameOptions={classNameOptions && classNameOptions}
                        color={settings.app.theme}
                    />
                )}
            </div>
        );
    }
}
